import React from 'react'
import { Text } from 'react-native'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import Styles from './Styles.js'


const GrammarHelperButton = props => {
  const {size, onPress} = props
  return (
    <Text onPress={onPress}>
      <FontAwesomeIcon size={size} color="#888888" icon={faQuestionCircle} />
    </Text>
  )
}

export default GrammarHelperButton
